import { generatePath } from 'react-router-dom';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { ShippingTier } from 'types';
import { addParamsToUrl } from 'utils/query';

import { apiQuery } from '../../query';

import {
  GetShippingCost,
  CreateShippingTier,
  UpdateShippingTier,
} from './types';

const tagTypes = ['shippingTier'];

export const shippingTierApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'shippingTierApi',
  endpoints: (build) => ({
    list: build.query<ShippingTier[], void>({
      providesTags: tagTypes,
      query: () => ({
        method: 'get',
        url: URL.GET_SHIPPING_TIERS,
      }),
    }),

    create: build.mutation<ShippingTier, CreateShippingTier>({
      invalidatesTags: tagTypes,
      query: (data) => ({
        data,
        method: 'post',
        url: URL.GET_SHIPPING_TIERS,
      }),
    }),

    delete: build.mutation<void, number>({
      invalidatesTags: tagTypes,
      query: (id) => ({
        method: 'delete',
        url: generatePath(URL.UPDATE_SHIPPING_TIER, { id: String(id) }),
      }),
    }),

    cost: build.query<ShippingTier, GetShippingCost>({
      providesTags: tagTypes,
      query: (params) => ({
        method: 'get',
        headers: { 'allow-not-found': '1' },
        url: addParamsToUrl(URL.GET_SHIPPING_COST, params),
      }),
    }),

    update: build.mutation<ShippingTier, UpdateShippingTier>({
      invalidatesTags: tagTypes,
      query: ({ id, ...data }) => ({
        data,
        method: 'patch',
        url: generatePath(URL.UPDATE_SHIPPING_TIER, { id: String(id) }),
      }),
    }),
  }),
});

export const {
  useCostQuery,
  useListQuery,
  useCreateMutation,
  useDeleteMutation,
  useUpdateMutation,
} = shippingTierApi;
